import { CrudOperators, CrudFilters, CrudSort } from '@refinedev/core';

export interface SearchQuery {
  filters?: Array<SearchFilter>;
  orderBy?: string;
  orderDirection?: string;
}

export interface SearchFilter {
  filterType: string;
  field: string;
  value: any;
}

export const mapOperator = (operator: CrudOperators): string => {
  switch (operator) {
    case 'contains':
      return 'ICONTAINS';
    case 'ncontains':
      return 'INOTCONTAINS';
    case 'startswith':
      return 'ISTARTSWITH';
    case 'nstartswith':
      return 'INOTSTARTSWITH';
    case 'null':
      return 'ISNULL';
    case 'nnull':
      return 'ISNOTNULL';
    case 'ne':
      return 'NEQ';
    case 'nin':
      return 'NOTIN';
    default:
      return `${operator}`.toUpperCase();
  }
};

const transformValue = (value: any): string => {
  return value.toString();
};

const transformFilter = (filter: any) => {
  const { value } = filter;
  let { field, operator } = filter;

  if ((field === 'name' || field === 'customerName' || field === 'vendorName') && operator === 'eq')
    operator = 'startswith';

  if (field === 'brands.0.name') {
    field = 'vendorBrandName';
    operator = 'contains';
  }

  return {
    field: field,
    filterType: mapOperator(operator),
    value: transformValue(value),
  };
};

export const generateFilter = (filters?: CrudFilters) => {
  const queryFilters: Array<SearchFilter> = [];

  if (filters) {
    filters.map(filter => {
      if (filter.operator === 'or' || filter.operator === 'and') {
        throw new Error(
          `[@refinedev/simple-rest]: \`operator: ${filter.operator}\` is not supported. You can create custom data provider. https://refine.dev/docs/api-reference/core/providers/data-provider/#creating-a-data-provider`,
        );
      }

      if ('field' in filter) {
        queryFilters.push(transformFilter(filter));
      }
    });
  }

  return queryFilters;
};

export const generateSortParams = (sorters?: Array<CrudSort>) => {
  if (sorters && sorters.length > 0) {
    const sort = sorters[0];
    return {
      orderBy: sort.field,
      orderDirection: sort.order.toUpperCase(),
    };
  } else {
    return {
      orderBy: 'id',
      orderDirection: 'desc'.toUpperCase(),
    };
  }
};
